var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"pm-logo",attrs:{"src":"https://templates-v2.kvass.no/custom-pm-1/assets/logo_small.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }